import React, { useEffect } from 'react';
import { useCrossFlow, Journeys, Targets } from '@atlassiansox/cross-flow-support';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import { useIntl } from '@atlassian/jira-intl';
import { useFireCrossFlowAnalyticsEvents as useFireCrossFlowAnalyticsEventsBase } from '@atlassian/surface-analytics';
import { messages } from './messages';

type Props = {
	isAdmin: boolean;
};

export const sourceComponent = 'on-call-schedule-navigation-item';

export const TryItNowComponent = ({ isAdmin }: Props) => {
	const { formatMessage } = useIntl();

	const crossFlow = useCrossFlow();
	const { fireInteractedUIEvent, fireViewedUIEvent } = useFireCrossFlowAnalyticsEventsBase();

	const onClickTry = () => {
		// UCIA: Fire an analytics event for clicking Try Opsgenie button
		fireInteractedUIEvent(
			{
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'tryOpsgenieButton',
			},
			{
				targetProductId: Targets.OPSGENIE,
				recommendedProductIds: [Targets.OPSGENIE],
				source: 'onCallScheduleRecommendationSection',
			},
		);
		crossFlow.isEnabled &&
			crossFlow.api.open({
				journey: Journeys.GET_STARTED,
				targetProduct: Targets.OPSGENIE,
				sourceComponent,
				sourceContext: 'jira',
			});
	};

	const onClickLearnMore = () => {
		// UCIA: Fire an analytics event for clicking Learn More button
		fireInteractedUIEvent(
			{
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'learnMoreButton',
			},
			{
				targetProductId: Targets.OPSGENIE,
				recommendedProductIds: [Targets.OPSGENIE],
				source: 'onCallScheduleRecommendationSection',
			},
		);
		crossFlow.isEnabled &&
			crossFlow.api.open({
				journey: Journeys.DECIDE,
				targetProduct: Targets.OPSGENIE,
				sourceComponent: 'oncall-schedule',
				sourceContext: 'jira',
			});
	};

	useEffect(() => {
		// UCIA: Fire an analytics event for viewing onCallScheduleRecommendation section

		fireViewedUIEvent(
			{
				action: 'viewed',
				actionSubject: 'section',
				actionSubjectId: 'onCallScheduleRecommendation',
			},
			{
				source: 'onCallScheduleScreen',
				recommendedProductIds: [Targets.OPSGENIE],
			},
		);
	}, [fireViewedUIEvent]);

	return (
		<EmptyState
			size="wide"
			maxImageWidth={131}
			header={formatMessage(messages.opsgenieSchedulePromoHeading)}
			description={formatMessage(messages.opsgenieSchedulePromoInfo)}
			primaryAction={
				<Button appearance="primary" onClick={onClickTry}>
					{formatMessage(
						isAdmin
							? messages.opsgenieSchedulePromoTryNowButton
							: messages.opsgenieSchedulePromoRequestTrialButton,
					)}
				</Button>
			}
			secondaryAction={
				<Button onClick={onClickLearnMore}>
					{formatMessage(messages.opsgenieSchedulePromoLearnMoreButton)}
				</Button>
			}
		/>
	);
};

export default TryItNowComponent;
